import { BaseError } from '@webapp/core/utils/errors/BaseError'

type ERRORS = 'SEARCH_FAILED'

export class GlobalSearchUseCaseErrors extends BaseError<ERRORS> {}
